import Vue from "vue";
import VueRouter from "vue-router";

import DashboardView from "../view/pages/dashboard/dashboard.vue";

// Ideation
import IdeationDetailView from "../view/pagesv2/ideation/details.vue";
import IdeationView from "../view/pagesv2/ideation/main.vue";

// Approval
import Error4040View from "../view/pages/Error404.vue";
import ProfileView from "../view/pages/profile/profile.vue";

// Genta Gendis
import GentaGendisView from "../view/pagesv2/gentagendis/gentangendis.vue";

// Genta Gendis
import fileManagement from "../view/pages/file/file.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: DashboardView,
  },
  {
    path: "/genta-gendis",
    name: "Genta/Gendi",
    component: GentaGendisView,
  },
  {
    path: "/file-management",
    name: "File Management",
    component: fileManagement,
  },
  {
    path: "/ideation",
    name: "Ideation",
    component: IdeationView,
  },
  {
    path: "/ideation/details/:id",
    name: "ideationDetails",
    component: IdeationDetailView,
  },
  {
    path: "/masterData/genta-gendis",
    name: "Genta/Gendis",
    component: GentaGendisView,
  },
  {
    path: "/profile",
    name: "Profile",
    component: ProfileView,
  },
  {
    path: "*",
    name: "Error404",
    component: Error4040View,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

//define route for handle authentication
// router.beforeEach((to, from, next) => {
//     let getStorage = localStorage.getItem('ugems-tokenParsed')
//     getStorage = JSON.parse(getStorage) || { data: {} }
//     if (to.meta.auth) {
//         if (getStorage.data.accessToken) {
//             return next()
//         } else {
//             return next('/login')
//         }
//     }
// })

export default router;
